import {Action} from '@ngrx/store';
import {GroupRole} from '../models/groupe-role';
import {type} from '../utilities/type';


// TODO: not used

export const groupRolesActionTypes = {
  LOAD: type('[Group Roles] Load'),
  LOAD_SUCCESS: type('[Group Roles] Load Success'),
  LOAD_FAIL: type('[Group Roles] Load Fail')
};

export class LoadGroupRolesAction implements Action {
  readonly type = groupRolesActionTypes.LOAD;
  constructor() {}
}

export class LoadGroupRolesSuccessAction implements Action {
  readonly type = groupRolesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: GroupRole[]) {}
}

export class LoadGroupRolesFailAction implements Action {
  readonly type = groupRolesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
